module.exports = __webpack_public_path__ + "img/IconHeld.463b2d23.svg";